(function () {
  'use strict';

  function initSection(scriptEl) {
    var sectionId = scriptEl.getAttribute('data-kr-section-id');
    var root = document.getElementById('kr-' + sectionId);
    if (!root || root.dataset.krInitialised === 'true') return;

    root.dataset.krInitialised = 'true';

    var bundlesVarName = '__KR_BUNDLES_' + sectionId.replace(/-/g, '');
    var bundles = window[bundlesVarName] || { men: {}, women: {} };

    var state = {
      men: {
        style: null,
        size: null,
        tier: 'Men Essential',
        tierLabel: 'The Essential'
      },
      women: {
        style: null,
        size: null,
        tier: 'Women Essential',
        tierLabel: 'The Essential'
      }
    };

    var currentGender = 'men';

    /* --------------------------------
       ELEMENTS
    -------------------------------- */

    var summaryGarment = root.querySelector('[data-kr-summary-garment]');
    var summaryTier = root.querySelector('[data-kr-summary-tier]');
    var summaryTotal = root.querySelector('[data-kr-total]');
    var addBtn = root.querySelector('[data-kr-add-btn]');
    var addLabel = root.querySelector('[data-kr-add-label]');
    var note = root.querySelector('[data-kr-note]');

    /* --------------------------------
       HELPERS
    -------------------------------- */

    function normalise(value) {
      return String(value || '').trim().toLowerCase();
    }

    function parseVariants(swatch) {
      var raw = swatch.getAttribute('data-kr-variants');

      if (!raw) {
        console.warn('KELI Gift Box: No variant data found', swatch);
        return [];
      }

      try {
        return JSON.parse(raw);
      } catch (error) {
        console.error(
          'KELI Gift Box: Could not parse variants',
          raw,
          error
        );
        return [];
      }
    }

    function getVariantSize(variant) {
      /*
       * Shopify may expose the size as:
       * option1
       * option2
       * option3
       * public_title
       * or title
       *
       * This tries them in a sensible order.
       */

      var options = [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter(Boolean);

      var recognisedSize = options.find(function (option) {
        var value = normalise(option);

        return [
          'xs',
          's',
          'm',
          'l',
          'xl',
          'xxl',
          '2xl',
          '3xl'
        ].indexOf(value) !== -1;
      });

      if (recognisedSize) return recognisedSize;

      if (
        variant.public_title &&
        !/default/i.test(variant.public_title)
      ) {
        return variant.public_title;
      }

      if (variant.title && !/default/i.test(variant.title)) {
        /*
         * If title is something like:
         * Sintra / M
         * return the last component.
         */
        var parts = variant.title.split(' / ');
        return parts[parts.length - 1];
      }

      return null;
    }

    /* --------------------------------
       TABS
    -------------------------------- */

    var tabs = root.querySelectorAll('[data-kr-tab]');
    var panels = root.querySelectorAll('[data-kr-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var gender = tab.getAttribute('data-kr-tab');
        currentGender = gender;

        tabs.forEach(function (t) {
          var active = t === tab;

          t.classList.toggle('is-active', active);
          t.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
        });

        panels.forEach(function (panel) {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-kr-panel') === gender
          );
        });

        updateSummary();
      });
    });

    /* --------------------------------
       SWATCHES
    -------------------------------- */

    ['men', 'women'].forEach(function (gender) {
      var swatchWrap = root.querySelector(
        '[data-kr-swatches="' + gender + '"]'
      );

      if (!swatchWrap) return;

      var swatches = swatchWrap.querySelectorAll('.kr__swatch');

      function selectSwatch(swatch) {
        swatches.forEach(function (item) {
          var active = item === swatch;

          item.classList.toggle('is-active', active);
          item.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );
        });

        var variants = parseVariants(swatch);

        state[gender].style =
          swatch.getAttribute('data-kr-product-title');

        state[gender].size = null;

        renderSizePills(gender, variants);
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          selectSwatch(swatch);
        });
      });

      if (swatches.length) {
        selectSwatch(swatches[0]);
      }
    });

    /* --------------------------------
       SIZE BUTTONS
    -------------------------------- */

    function renderSizePills(gender, variants) {
      var pillsWrap = root.querySelector(
        '[data-kr-size-pills="' + gender + '"]'
      );

      var sizesRow = root.querySelector(
        '[data-kr-sizes="' + gender + '"]'
      );

      if (!pillsWrap || !sizesRow) return;

      pillsWrap.innerHTML = '';

      if (!variants || !variants.length) {
        sizesRow.style.display = '';

        console.warn(
          'KELI Gift Box: No variants available for',
          state[gender].style
        );

        updateSummary();
        return;
      }

      var onlyDefault =
        variants.length === 1 &&
        /default/i.test(variants[0].title || '');

      if (onlyDefault) {
        sizesRow.style.display = 'none';
        state[gender].size = 'One Size';

        updateSummary();
        return;
      }

      sizesRow.style.display = '';

      /*
       * Group Shopify variants by size so we don't
       * accidentally create duplicate S/M/L buttons.
       */

      var sizeMap = {};

      variants.forEach(function (variant) {
        var size = getVariantSize(variant);

        if (!size) return;

        if (!sizeMap[size]) {
          sizeMap[size] = {
            size: size,
            available: false
          };
        }

        if (variant.available) {
          sizeMap[size].available = true;
        }
      });

      var preferredOrder = [
        'XS',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        '2XL',
        '3XL'
      ];

      var sizes = Object.keys(sizeMap);

      sizes.sort(function (a, b) {
        var ai = preferredOrder.indexOf(a.toUpperCase());
        var bi = preferredOrder.indexOf(b.toUpperCase());

        if (ai === -1) ai = 999;
        if (bi === -1) bi = 999;

        return ai - bi;
      });

      var firstAvailable = null;

      sizes.forEach(function (size) {
        var data = sizeMap[size];

        var btn = document.createElement('button');

        btn.type = 'button';
        btn.className = 'kr__size-pill';
        btn.textContent = size;
        btn.disabled = !data.available;
        btn.setAttribute('aria-pressed', 'false');

        if (!data.available) {
          btn.classList.add('is-disabled');
        }

        btn.addEventListener('click', function () {
          if (btn.disabled) return;

          pillsWrap
            .querySelectorAll('.kr__size-pill')
            .forEach(function (pill) {
              pill.classList.remove('is-active');
              pill.setAttribute('aria-pressed', 'false');
            });

          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          state[gender].size = size;

          updateSummary();
        });

        pillsWrap.appendChild(btn);

        if (data.available && !firstAvailable) {
          firstAvailable = btn;
        }
      });

      /*
       * Automatically select the first available size.
       */

      if (firstAvailable) {
        firstAvailable.click();
      } else {
        state[gender].size = null;
        updateSummary();
      }
    }

    /* --------------------------------
       TIERS
    -------------------------------- */

    ['men', 'women'].forEach(function (gender) {
      var tierWrap = root.querySelector(
        '[data-kr-tiers="' + gender + '"]'
      );

      if (!tierWrap) return;

      var radios = tierWrap.querySelectorAll(
        'input[type="radio"]'
      );

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          tierWrap
            .querySelectorAll('.kr__tier')
            .forEach(function (label) {
              var active =
                label.contains(radio) &&
                radio.checked;

              label.classList.toggle(
                'is-active',
                active
              );
            });

          state[gender].tier = radio.value;

          state[gender].tierLabel =
            radio.getAttribute(
              'data-kr-tier-label'
            );

          updateSummary();
        });
      });
    });

    /* --------------------------------
       BUNDLE VARIANT LOOKUP
    -------------------------------- */

    function findBundleVariant() {
      var s = state[currentGender];

      if (!s.style || !s.size) return null;

      var tierVariants =
        (bundles[currentGender] || {})[s.tier] || [];

      /*
       * First try Shopify option values.
       * This is more reliable than matching the
       * full variant title.
       */

      for (var i = 0; i < tierVariants.length; i++) {
        var variant = tierVariants[i];

        var optionValues = [
          variant.option1,
          variant.option2,
          variant.option3
        ].filter(Boolean);

        var styleMatch = optionValues.some(function (value) {
          return normalise(value) === normalise(s.style);
        });

        var sizeMatch = optionValues.some(function (value) {
          return normalise(value) === normalise(s.size);
        });

        if (styleMatch && sizeMatch) {
          return variant;
        }
      }

      /*
       * Fallback to full variant title.
       */

      var wantedTitle =
        normalise(s.style + ' / ' + s.size);

      for (var j = 0; j < tierVariants.length; j++) {
        if (
          normalise(tierVariants[j].title) ===
          wantedTitle
        ) {
          return tierVariants[j];
        }
      }

      console.warn(
        'KELI Gift Box: No matching bundle variant',
        {
          gender: currentGender,
          style: s.style,
          size: s.size,
          tier: s.tier
        }
      );

      return null;
    }

    /* --------------------------------
       SUMMARY
    -------------------------------- */

    function updateSummary() {
      var s = state[currentGender];
      var bundleVariant = findBundleVariant();

      if (summaryGarment) {
        summaryGarment.textContent = s.style
          ? s.style +
            (
              s.size &&
              s.size !== 'One Size'
                ? ' — ' + s.size
                : ''
            )
          : 'Choose your piece';
      }

      if (summaryTier) {
        summaryTier.textContent =
          s.tierLabel + ' box';
      }

      if (bundleVariant) {
        if (summaryTotal) {
          summaryTotal.textContent =
            '€' +
            (bundleVariant.price / 100)
              .toFixed(2)
              .replace('.', ',');
        }

        if (addBtn) {
          addBtn.disabled =
            !bundleVariant.available;
        }

        if (note) {
          note.textContent =
            bundleVariant.available
              ? ''
              : 'This size is currently unavailable.';

          note.className =
            bundleVariant.available
              ? 'kr__summary-note'
              : 'kr__summary-note is-error';
        }
      } else {
        if (summaryTotal) {
          summaryTotal.textContent = '€—';
        }

        if (addBtn) {
          addBtn.disabled = true;
        }

        if (note) {
          note.textContent =
            s.style && s.size
              ? 'This combination is currently unavailable.'
              : '';

          note.className =
            'kr__summary-note';
        }
      }
    }

    updateSummary();

    /* --------------------------------
       ADD TO CART
    -------------------------------- */

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var bundleVariant = findBundleVariant();
        var s = state[currentGender];

        if (!bundleVariant) return;

        addBtn.disabled = true;

        if (addLabel) {
          addLabel.textContent = 'Adding…';
        }

        if (note) {
          note.textContent = '';
          note.className = 'kr__summary-note';
        }

        var payload = {
          items: [
            {
              id: bundleVariant.id,
              quantity: 1,
              properties: {
                'Gift Box': s.tierLabel,
                'Style': s.style,
                'Size': s.size
              }
            }
          ]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw err;
              });
            }

            return res.json();
          })
          .then(function () {
            if (note) {
              note.textContent = 'Added to cart.';
              note.className =
                'kr__summary-note is-success';
            }

            if (addLabel) {
              addLabel.textContent =
                'Add gift box to cart';
            }

            window.location.href = '/cart';
          })
          .catch(function (err) {
            if (note) {
              note.textContent =
                (err && err.description) ||
                'Something went wrong — please try again.';

              note.className =
                'kr__summary-note is-error';
            }

            if (addLabel) {
              addLabel.textContent =
                'Add gift box to cart';
            }

            addBtn.disabled = false;
          });
      });
    }
  }

  document
    .querySelectorAll(
      'script[data-kr-section-id]'
    )
    .forEach(initSection);
})();